module.exports = __webpack_public_path__ + "img/mega-lab-hawaii-poster.f1efc543.jpg";